/**
 * IDs de toasts ignorés/fermés pour la durée de la session navigateur (pas de persistance DB).
 */

const dismissedEventKeys = new Set();

export function isCommandeToastDismissed(eventKey) {
  return dismissedEventKeys.has(eventKey);
}

export function markCommandeToastDismissed(eventKey) {
  if (eventKey) {
    dismissedEventKeys.add(eventKey);
  }
}

/** Tests uniquement */
export function resetCommandeToastDismissSessionForTests() {
  dismissedEventKeys.clear();
}
